import { apiWrapper } from "apis/CommonApi";
import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import * as accountApi from "../apis/AccountApi";

export default function ResetPasswordPage() {
    return (
        <div id="wrap">
            <Main />
        </div>
    );
}

function Main() {
    return (
        <main id="main" className="main">
            <HeadSection />
            <JoinSection />
        </main>
    );
}

function HeadSection() {
    return (
        <section class="headSection">
            <div class="container cont-960">
                <div class="wrap_head">
                    <div class="wrap_title wrap_txt_title">
                        <Link class="logo bold" to="/">LOGO</Link>
                        <span class="bar"></span>
                        <p class="title">비밀번호 재설정을 요청하셨습니다. <br class="mb" /> 아래 비밀번호 재설정을 통해 새 비밀번호를 설정해주세요.</p>
                    </div>
                </div>
            </div>
        </section>
    );
}

function JoinSection() {
    const { uidb64, token } = useParams();
    const [formData, setFormData] = useState(null);
    const [isPasswordMatch, setPasswordMatch] = useState(false); // 비밀번호 일치 여부
    const [isCompletedPassword, setCompletedPassword] = useState(false); // 비밀번호 입력 완료 여부
    const [isCompletedPasswordConfirm, setCompletedPasswordConfirm] = useState(false); // 비밀번호 확인 입력 완료 여부

    useEffect(() => {
        setFormDataProperty("password", "");
        setFormDataProperty("passwordConfirm", "");
    }, []);

    const setFormDataProperty = (name, value) => {
        setFormData((currentFormData) => {
            const nextFormData = {
                ...currentFormData,
                [name]: value,
            };
            //console.log(nextFormData);
            return nextFormData;
        });
    };

    const onChange = (e) => {
        let name = e.target.name;
        let value = e.target.value;
        setFormDataProperty(name, value);
    };

    const handleSubmit = (e) => {
        e.preventDefault();

        const form = e.currentTarget;
        if (form.checkValidity() === false) {
            e.stopPropagation();
        } else if (checkValid() === false) {
            e.stopPropagation();
        } else {
            apiWrapper(async () => {
                const { password } = formData;
                const { status, data } = await accountApi.resetPassword(uidb64, token, password);
                if (data) {
                    alert(`${data}`);
                }
            });
        }
    }

    const checkValid = () => {
        if (isPasswordMatch === false) {
            alert("패스워드를 확인해주세요.");
        }

        return true;
    }

    const handleCheckPasswordMatch = () => {
        if (formData.password === formData.passwordConfirm) {
            setPasswordMatch(true);
        }
        else {
            setPasswordMatch(false);
        }
    }

    return (
        <section class="joinSection">
            <div class="container cont-960">
                <form onSubmit={handleSubmit}>
                    {formData && (
                        <div class="whiteBoard wrap_findId">
                            <button class="btn_prev">
                                <i class="x-icon icon_prev"></i>
                            </button>
                            <p class="title_whiteBoard">패스워드 재설정</p>
                            <div class="wrap_input">
                                <div class="item_input">
                                    <p class="title_item">새 패스워드</p>
                                    <input type="password" class="defaultInput" name="password" value={formData.password} onChange={onChange}
                                        onBlur={() => {
                                            formData.password ? setCompletedPassword(true) : setCompletedPassword(false);
                                            handleCheckPasswordMatch();
                                        }}
                                        required="required" />
                                </div>
                                <div class="item_input">
                                    <p class="title_item">새 패스워드 확인</p>
                                    <input type="password" class="defaultInput" name="passwordConfirm" value={formData.passwordConfirm} onChange={onChange}
                                        onBlur={() => {
                                            formData.passwordConfirm ? setCompletedPasswordConfirm(true) : setCompletedPasswordConfirm(false);
                                            handleCheckPasswordMatch();
                                        }}
                                        required="required" />
                                </div>
                                {(isCompletedPassword && isCompletedPasswordConfirm) &&
                                    isPasswordMatch === false && (
                                        <div className="wrap_guide red">
                                            <i className="x-icon txt_guide"></i>
                                            <p className="txt_guide">패스워드가 동일하지 않습니다.</p>
                                        </div>
                                    )}
                            </div>
                            <button class="btn_orange btn_findId" type="submit">패스워드 변경</button>
                        </div>
                    )}
                </form>
            </div>
        </section >
    );
}
